import axios from 'axios';

export function get(url,params={}) {
    return new Promise(((resolve, reject) =>{
        axios.get(url, {
            // 传递参数
            params: params
            // 设置请求头信息，可以传递空值
        }).then(response => {
            // 请求成功
             resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}

export function post(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.post(url, data).then(response => {
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


export function patch(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.patch(url,data).then(response => {
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


export function put(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.put(url,data).then(response => {
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}

export function del(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.delete(url,data).then(response => {
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}

